import styled, { css } from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { getTextStyles } from '@yme/utils/styles';
import { SpinnerLoader } from '../spinner-loader';
import { SpinnerLoaderMaskStyled } from '../spinner-loader/styled';
import { BTN_CONTAINED_CFG, BTN_FADED_CFG, BTN_GHOST_CFG, BTN_TEXT_CFG, BTN_DARK_THEME, ICON_ONLY, SIZE_36, } from './constants';
import { getStylesButtonBySize, getStylesOnlyIconButtonBySize } from './helpers';
const svgPath = (fillValue) => css `
  svg > path,
  svg > g > path {
    fill: ${fillValue};
  }
`;
export const DefaultButtonStyled = styled.button `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  height: ${({ size }) => size};
  width: ${({ width }) => width};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  text-transform: uppercase;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: nowrap;

  &:active {
    box-shadow: none;
  }

  &:disabled,
  &:disabled:active,
  &:disabled:hover {
    box-shadow: none;
    cursor: not-allowed;
  }

  transition: background-color 150ms, border-color 150ms, color 50ms ease-in-out;

  ${({ size = SIZE_36, hasIconButton }) => hasIconButton === ICON_ONLY
    ? getStylesOnlyIconButtonBySize({
        size,
    })
    : getStylesButtonBySize({
        size,
    })};

  // Note: General fix - hide 'highlight-color' effect for mobile devices in clicked time
  -webkit-tap-highlight-color: transparent;
`;
export const SVGIconCustomStyled = styled(SVGIcon) `
  order: ${({ order }) => order};

  ${({ iconRotate }) => iconRotate && `transform: rotate(${iconRotate}deg);`};
`;
export const SVGIconCustomWrapperStyled = styled.span `
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const LabelStyled = styled.span `
  order: 2;
  text-align: center;
  white-space: normal;
  overflow-wrap: break-word;
`;
const buildButtonStyles = ({ isPressed, isHovered, config, isRightToLeft, isColorIcon = false, }) => css `
  border-color: ${config.default.border};
  background-color: ${config.default.bg};
  color: ${config.default.color};

  ${!isColorIcon && svgPath(config.default.color)}

  svg {
    transform: rotate(${isRightToLeft ? '180deg' : '0deg'});
  }

  @media (hover: hover) {
    &:active,
    &:hover {
      color: ${config.hoverActive.color};
      border-color: ${config.hoverActive.border};
      background-color: ${config.hoverActive.bg};

      ${!isColorIcon && svgPath(config.hoverActive.color)}
    }
  }

  &:disabled,
  &:disabled:active,
  &:disabled:hover {
    color: ${config.disabled.color};
    border-color: ${config.disabled.border};
    background-color: ${config.disabled.bg};

    ${svgPath(config.disabled.color)}
  }

  ${() => (isPressed || isHovered) &&
    css `
      color: ${config.hoverActive.color};
      border-color: ${config.hoverActive.border};
      background-color: ${config.hoverActive.bg};

      ${svgPath(config.hoverActive.color)}
    `}
`;
export const ButtonContained = styled(DefaultButtonStyled) `
  ${({ colorSchema, isDarkMode, ...rest }) => colorSchema === BTN_DARK_THEME || isDarkMode
    ? buildButtonStyles({
        ...rest,
        config: BTN_CONTAINED_CFG.DARK,
    })
    : buildButtonStyles({
        ...rest,
        config: BTN_CONTAINED_CFG.LIGHT,
    })}
`;
export const ButtonGhost = styled(DefaultButtonStyled) `
  ${({ colorSchema, isDarkMode, ...rest }) => colorSchema === BTN_DARK_THEME || isDarkMode
    ? buildButtonStyles({
        ...rest,
        config: BTN_GHOST_CFG.DARK,
    })
    : buildButtonStyles({
        ...rest,
        config: BTN_GHOST_CFG.LIGHT,
    })}
`;
export const ButtonFaded = styled(DefaultButtonStyled) `
  ${({ colorSchema, isDarkMode, ...rest }) => colorSchema === BTN_DARK_THEME || isDarkMode
    ? buildButtonStyles({
        ...rest,
        config: BTN_FADED_CFG.DARK,
    })
    : buildButtonStyles({
        ...rest,
        config: BTN_FADED_CFG.LIGHT,
    })}
`;
export const ButtonText = styled(DefaultButtonStyled) `
  ${({ colorSchema, isDarkMode, ...rest }) => colorSchema === BTN_DARK_THEME || isDarkMode
    ? buildButtonStyles({
        ...rest,
        config: BTN_TEXT_CFG.DARK,
    })
    : buildButtonStyles({
        ...rest,
        config: BTN_TEXT_CFG.LIGHT,
    })}
`;
// Custom styled for Button with Image as background
export const ImageButtonStyled = styled.button `
  display: flex;
  border: none;
  box-sizing: border-box;
  white-space: nowrap;
  align-items: center;
  padding: 0;
  cursor: pointer;

  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
`;
export const SpinnerLoaderStyled = styled(SpinnerLoader) `
  ${SpinnerLoaderMaskStyled} {
    position: relative;
    background-color: transparent;
  }
`;
